module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/characters/ian_sara_lean_smile-12d488cb6a6d1d48a6f2c910bc4b245d.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/characters/ian_sara_lean_smile.png
// module id = 417
// module chunks = 2